import React from 'react';
import { Church, BookOpen, Heart } from 'lucide-react';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <Church size={48} />,
      title: 'Dimanche / Sunday / Sonntag',
      time: '10:30',
      description: ['Culte Principal', 'Main Service', 'Hauptgottesdienst']
    },
    {
      icon: <BookOpen size={48} />,
      title: 'Mercredi / Wednesday / Mittwoch',
      time: '18:30',
      description: ['Étude Biblique', 'Bible Study', 'Bibelstudium']
    },
    {
      icon: <Heart size={48} />,
      title: 'Vendredi / Friday / Freitag',
      time: '18:30',
      description: ['Prière & Louange', 'Prayer & Worship', 'Gebet & Anbetung']
    }
  ];

  return (
    <section id="services" className="section">
      <div className="container">
        <h2 className="section-title">Nos Services / Our Services / Unsere Gottesdienste</h2>
        <p className="pastor-info">
          Avec Pastor Eddy / With Pastor Eddy / Mit Pst. Eddy
        </p>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card" style={{ animationDelay: `${index * 0.2}s` }}>
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <div className="service-time">{service.time}</div>
              {service.description.map((desc, i) => (
                <p key={i}>{desc}</p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
